module.exports = __webpack_public_path__ + "img/karaage_teisyoku.db59f277.jpg";